import { ICsvImportTemplateProps } from '@/imports/ui/components/csv/CsvImportTemplate';

export enum ESpecificGroupMemberCsvUploadFieldNames {
  USER_EMAIL = 'User Email',
}

const SpecificGroupMemberCsvUploadFieldMap: Record<
  ESpecificGroupMemberCsvUploadFieldNames,
  boolean
> = {
  'User Email': true,
};

export const SPECIFIC_GROUP_MEMBER_CSV_UPLOAD_TEMPLATE: ICsvImportTemplateProps<
  typeof SpecificGroupMemberCsvUploadFieldMap
> = {
  filename: 'groups_users_template.csv',
  rows: [
    {
      'User Email': 'jerry@example.com',
    },
    {
      'User Email': 'steph@example.com',
    },
    {
      'User Email': 'dave@example.com',
    },
  ],
};
